// extracted by mini-css-extract-plugin
export default {"figure":"Figure_figure__FZhlB","figureEatable":"Figure_figureEatable__MwYsd"};